var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { all, call, put, select, takeLatest, } from 'redux-saga/effects';
import { getSelectedCategoryId } from '../../categories';
import { runActionAfterDelay } from '../../utils/sagas';
import { getJrniCategoryId, getJrniGrandParentId, getJrniOnlineCategoryId, getJrniVirtualHubID, getWoosmapApiKey, } from '../../utils';
import { ActionTypes as CoordinatesActionTypes, getCoordinates, } from '../coordinates';
import { actions, ActionTypes } from './actions';
import { fetchOnlineAppointmentStore, fetchStoreOpeningHours, fetchStores, fetchStoresDistances, } from './requests';
import { getStores, getVirtualHubStore } from './selectors';
import { processOpeningHours, processStores, processStoresDistances, isClosestStoreHandledByHub, processVirtualHubStore, } from './utils';
export function loadStores() {
    var jrniGrandparentId, selectedCategoryId, coordinates, jrniCategoryId, onlineCategoryId, storesResponse, stores, data, updatedData, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 15, , 17]);
                return [4 /*yield*/, put(actions.loadStores())];
            case 1:
                _a.sent();
                return [4 /*yield*/, select(getJrniGrandParentId)];
            case 2:
                jrniGrandparentId = _a.sent();
                return [4 /*yield*/, select(getSelectedCategoryId)];
            case 3:
                selectedCategoryId = _a.sent();
                return [4 /*yield*/, select(getCoordinates)];
            case 4:
                coordinates = _a.sent();
                return [4 /*yield*/, select(getJrniCategoryId)];
            case 5:
                jrniCategoryId = _a.sent();
                return [4 /*yield*/, select(getJrniOnlineCategoryId)];
            case 6:
                onlineCategoryId = _a.sent();
                return [4 /*yield*/, call(fetchStores, jrniGrandparentId, selectedCategoryId, coordinates)];
            case 7:
                storesResponse = _a.sent();
                stores = processStores(storesResponse);
                return [4 /*yield*/, all(stores.map(function (store) {
                        var openingHoursResponse, openingHours;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, call(fetchStoreOpeningHours, store.jrniId)];
                                case 1:
                                    openingHoursResponse = _a.sent();
                                    openingHours = processOpeningHours(openingHoursResponse);
                                    return [2 /*return*/, __assign(__assign({}, store), { openingHours: openingHours })];
                            }
                        });
                    }))];
            case 8:
                data = _a.sent();
                return [4 /*yield*/, call(getStoresDistances, data, coordinates)];
            case 9:
                updatedData = _a.sent();
                if (!(isClosestStoreHandledByHub(stores) &&
                    jrniCategoryId === onlineCategoryId)) return [3 /*break*/, 12];
                return [4 /*yield*/, call(loadVirtualHubStore, updatedData)];
            case 10:
                _a.sent();
                return [4 /*yield*/, put(actions.loadStoresSuccess([]))];
            case 11:
                _a.sent();
                return [3 /*break*/, 14];
            case 12: return [4 /*yield*/, put(actions.loadStoresSuccess(updatedData))];
            case 13:
                _a.sent();
                _a.label = 14;
            case 14: return [3 /*break*/, 17];
            case 15:
                error_1 = _a.sent();
                return [4 /*yield*/, put(actions.loadStoresFailure(error_1))];
            case 16:
                _a.sent();
                return [3 /*break*/, 17];
            case 17: return [2 /*return*/];
        }
    });
}
export function loadVirtualHubStore(stores) {
    var coordinates, virtualHubID, virtualHubResponse, virtualHub, updatedVirtualHubStore, updatedData, processedVirtualHub, error_2;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 7, , 9]);
                return [4 /*yield*/, put(actions.loadVirtualHubStore())];
            case 1:
                _b.sent();
                return [4 /*yield*/, select(getCoordinates)];
            case 2:
                coordinates = _b.sent();
                return [4 /*yield*/, select(getJrniVirtualHubID)];
            case 3:
                virtualHubID = _b.sent();
                return [4 /*yield*/, call(fetchOnlineAppointmentStore, virtualHubID)];
            case 4:
                virtualHubResponse = _b.sent();
                virtualHub = processVirtualHubStore(virtualHubResponse);
                updatedVirtualHubStore = __assign(__assign({}, virtualHub), { address: stores && stores.length && ((_a = stores[0]) === null || _a === void 0 ? void 0 : _a.address) });
                return [4 /*yield*/, call(getStoresDistances, [updatedVirtualHubStore], coordinates)];
            case 5:
                updatedData = _b.sent();
                processedVirtualHub = updatedData && updatedData.length && updatedData[0];
                return [4 /*yield*/, put(actions.loadVirtualHubStoreSuccess(processedVirtualHub))];
            case 6:
                _b.sent();
                return [3 /*break*/, 9];
            case 7:
                error_2 = _b.sent();
                return [4 /*yield*/, put(actions.loadVirtualHubStoreFailure(error_2))];
            case 8:
                _b.sent();
                return [3 /*break*/, 9];
            case 9: return [2 /*return*/];
        }
    });
}
export function setDefaultActiveStore() {
    var virtualHubStore, firstStore;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getVirtualHubStore)];
            case 1:
                virtualHubStore = _a.sent();
                if (!virtualHubStore) return [3 /*break*/, 3];
                return [4 /*yield*/, put(actions.setActiveStore(virtualHubStore))];
            case 2:
                _a.sent();
                return [3 /*break*/, 6];
            case 3: return [4 /*yield*/, select(getStores)];
            case 4:
                firstStore = (_a.sent())[0];
                return [4 /*yield*/, put(actions.setActiveStore(firstStore || null))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6: return [2 /*return*/];
        }
    });
}
export function getStoresDistances(stores, coordinates) {
    var apiKey, distances, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 5]);
                return [4 /*yield*/, select(getWoosmapApiKey)];
            case 1:
                apiKey = _a.sent();
                return [4 /*yield*/, call(fetchStoresDistances, apiKey, stores, coordinates)];
            case 2:
                distances = _a.sent();
                return [4 /*yield*/, call(processStoresDistances, stores, distances)];
            case 3: return [2 /*return*/, _a.sent()];
            case 4:
                e_1 = _a.sent();
                return [2 /*return*/, stores];
            case 5: return [2 /*return*/];
        }
    });
}
export function sagas() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, takeLatest(CoordinatesActionTypes.SET_USER_COORDINATES, loadStores)];
            case 1:
                _a.sent();
                return [4 /*yield*/, takeLatest(ActionTypes.LOAD_STORES_SUCCESS, setDefaultActiveStore)];
            case 2:
                _a.sent();
                return [4 /*yield*/, takeLatest(ActionTypes.LOAD_VIRTUAL_HUB_STORE_SUCCESS, setDefaultActiveStore)];
            case 3:
                _a.sent();
                return [4 /*yield*/, takeLatest(ActionTypes.LOAD_STORES_FAILURE, function () {
                        return runActionAfterDelay(actions.removeStoresError());
                    })];
            case 4:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
